export default {
  text: 'You earn <highlight>{{value}} points</highlight> with this order',
};
